import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData,
} from './utils';
import { PixelsVideoEvent } from '../../constants/Video';

const completedTracker = ([type]: string[]) => {
  switch (type) {
    case PixelsVideoEvent.AD_ENDED:
    case PixelsVideoEvent.BEFORE_COMPLETE:
      return true;
    default:
      return false;
  }
};
export const completed = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const player$ = sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.AD_REQUEST, PixelsVideoEvent.FIRST_FRAME, PixelsVideoEvent.AD_ENDED, PixelsVideoEvent.BEFORE_COMPLETE, PixelsVideoEvent.VIDEO_CHANGE
    ].includes(type as PixelsVideoEvent)),
    map(completedTracker),
  );

  player$.subscribe((value) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    metricsLog(`Completed: ${value}`);

    setData(storageKey, {
      ...data,
      completed: {
        value,
      }
    });
  });
};